// Import model
import { FilterProjectNoteRequest } from '../models/FilterProjectNoteRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ProjectNoteCondition } from '../models/ProjectNoteCondition';
import { ProjectNoteFields } from '../models/ProjectNoteFields';
import { ProjectNoteIndexedFields } from '../models/ProjectNoteIndexedFields';

// Import dependency serializers (for complex types)
import { ProjectNoteConditionSerializer } from './ProjectNoteConditionSerializer';
import { ProjectNoteFieldsSerializer } from './ProjectNoteFieldsSerializer';
import { ProjectNoteIndexedFieldsSerializer } from './ProjectNoteIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterProjectNoteRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterProjectNoteRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterProjectNoteRequest instance
   */
  static deserialize(json: string): FilterProjectNoteRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterProjectNoteRequest instance
   */
  static fromObject(obj: any): FilterProjectNoteRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterProjectNoteRequest');
    }


    const instance: FilterProjectNoteRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as ProjectNoteIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as ProjectNoteFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        ProjectNoteConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterProjectNoteRequest instances
   */
  static deserializeArray(json: string): FilterProjectNoteRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterProjectNoteRequest instance to a JSON string
   */
  static serialize(instance: FilterProjectNoteRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterProjectNoteRequest instance to a plain object
   */
  static toObject(instance: FilterProjectNoteRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        ProjectNoteConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterProjectNoteRequest instances to a JSON string
   */
  static serializeArray(instances: FilterProjectNoteRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
